<template>
  <div
    class="group/product-card relative transform-gpu overflow-hidden bg-white transition hover:z-10"
    @mouseenter="onMouseEnter"
    @mouseleave="onMouseLeave"
  >
    <div class="relative">
      <div
        class="aspect-[360/450] w-full overflow-hidden bg-white"
        :style="{
          filter: `brightness(${imageBrightnessFilter}%)`,
          backgroundColor: imageBackgroundColor?.hexa || 'transparent',
        }"
      >
        <CommonProductCardImages
          class="block h-full w-full"
          :to="productLink"
          :is-hover="isHover"
          :images="productImages"
          :product="product"
          @click="setGaSelectItemEvent"
        />
      </div>
      <div
        class="absolute left-0 bottom-3 lg:bottom-4 w-full px-4 pointer-events-none"
        :style="{ textAlign: cardContentPosition || 'center' } as StyleValue"
      >
        <span
          class="ui-text-sm uppercase animated-underline transition duration-300 ease-out"
          :class="[
            productImages?.length > 1 && isHover
              ? 'text-white'
              : 'text-primary',
            isHover ? 'after:!w-full' : 'after:w-0',
          ]"
        >
          {{ productTitlePlp }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { CatalogData, ColorPickerData } from "ecom-types";
import { StyleValue } from "vue";
import { sizesSlugs } from "@/configs";

const props = withDefaults(
  defineProps<{
    hover?: boolean;
    imageBrightnessFilter?: string;
    cardContentPosition?: string;
    product: CatalogData;
    plpType?: string;
    extractSetting?: boolean;
    productIndex: number;
    statisticItemListName?: string;
    imageBackgroundColor?: ColorPickerData;
  }>(),
  {
    imageBrightnessFilter: "100",
    cardContentPosition: "center",
    productIndex: 0,
    statisticItemListName: "",
  },
);

const { productLink, productTitlePlp } = useProduct(props.product, sizesSlugs);

const { mdAndDown } = useAppBreakpoints();

const { selectItemEvent } = useEvents();

const isHover = ref<boolean>(false);

const productImages = computed(() => {
  const productImages = getProductImages(props.product);
  if (productImages?.length > 2) {
    productImages.length = 2;
  }
  return productImages;
});

function onMouseEnter() {
  if (mdAndDown.value) return;
  isHover.value = true;
}

function onMouseLeave() {
  isHover.value = false;
}

function setGaSelectItemEvent() {
  selectItemEvent(props.product, {
    index: props.productIndex,
    item_list_name: props.statisticItemListName,
  });
}
</script>
